import HomeHeader from './header/HomeHeader';
import HomeMainContent from './content/HomeMainContent';
import HomeFooter from './footer/HomeFooter';

import './HomeLayout.css'

const HomeLayout = ({children}) => {
  return (
    <div>
      <header className="site-header">
        <div className='header-container'>
          <HomeHeader showLoginButton={true} showSignupButton={true}/>
        </div>
      </header>
      <div className='main-content-container' style={{ paddingTop: '70px'}}>
        <HomeMainContent/>
      </div>
      <div className='footer-container'>
        <HomeFooter/>
      </div>
    </div>
  );
}

export default HomeLayout;